var _circle, _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnWbi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.0264,
    cy: 3.79402,
    r: 3.79402,
    fill: "#0149DA"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.83521,
    y: 14.9075,
    width: 7.20195,
    height: 7.20195,
    transform: "rotate(-45 4.83521 14.9075)",
    fill: "#0149DA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.91504 9.83228L11.025 8.72234C12.4312 7.31608 14.7112 7.31607 16.1175 8.72234C17.5238 10.1286 17.5238 12.4086 16.1175 13.8149L15.0076 14.9248L9.91504 9.83228Z",
    fill: "#2D72FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.85291 14.925L3.74297 13.8151C2.33671 12.4088 2.3367 10.1288 3.74297 8.72257C5.14924 7.3163 7.42925 7.3163 8.83552 8.72257L9.94545 9.8325L4.85291 14.925Z",
    fill: "#2D72FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnWbi);
export default __webpack_public_path__ + "static/media/icn_wbi.caeaa4395c06e035395779f85edee166.svg";
export { ForwardRef as ReactComponent };